/**
 * Maps AI JSON response keys → form field keys.
 * Extend per page/module as needed.
 */

export const CONTENT_AI_RESPONSE_FIELD_MAP = {
  ShortDesc: "shortDescription",
  FullDesc: "fullDescription",
  ReadingTime: "readingTime",
  PageTitle: "metaTitle",
  MetaKeys: "metaKeywords",
  MetaDesc: "metaDescription",
};

export const EVENT_AI_RESPONSE_FIELD_MAP = {
  Title: "eventName",
  ShortDesc: "shortDescription",
  FullDesc: "fullDescription",
  PageTitle: "metaTitle",
  MetaKeys: "metaKeywords",
  MetaDesc: "metaDescription",
};

export const SECTION_AI_RESPONSE_FIELD_MAP = {
  SectionDescription: "sectionDescription",
  PageTitle: "metaTitle",
  MetaKeys: "metaKeywords",
  MetaDesc: "metaDescription",
};

export const SUB_SECTION_AI_RESPONSE_FIELD_MAP = {
  SubSectionDescription: "subSectionDescription",
  PageTitle: "metaTitle",
  MetaKeys: "metaKeywords",
  MetaDesc: "metaDescription",
};

/** @deprecated Use SECTION_AI_RESPONSE_FIELD_MAP */
export const CONTENT_SECTION_AI_RESPONSE_FIELD_MAP = SECTION_AI_RESPONSE_FIELD_MAP;
